import React from "react";
import AllInfo from "./AllInfo";

const TaskCloumn = ({ taskval }) => {
  return (
    <>
      <div className="taskcolum">
        <AllInfo
          all={taskval}
          style={{
            background:
              "linear-gradient(90deg,rgb(231, 231, 231),rgb(255, 255, 255))",
          }}
        />
      </div>
    </>
  );
};

export default TaskCloumn;
